"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneInput = void 0;
const React = __importStar(require("react"));
const flags_png_1 = __importDefault(require("./flags.png"));
const react_telephone_input_1 = require("react-telephone-input");
const phone_input_styled_1 = require("./phone-input.styled");
const formatE164 = (tel) => tel.replace(/[()-]/g, '');
const PhoneInput = (props) => {
    const classNames = [];
    if (props.className)
        classNames.push(props.className);
    const onChange = (value, evt) => {
        if (props.onChange) {
            const event = Object.assign(Object.assign({}, evt), { value: formatE164(value) });
            props.onChange(event);
        }
    };
    const rtiProps = Object.assign(Object.assign({}, props), { defaultCountry: 'gb', preferredCountries: ['gb', 'ie', 'fr', 'es', 'it', 'gr', 'us'], flagsImagePath: String(flags_png_1.default), initialValue: props.value || '', classNames: classNames.join(' '), className: classNames.join(' '), onChange });
    return (React.createElement(phone_input_styled_1.StyledPhoneInputWrapper, { valid: props.invalid !== undefined ? !props.invalid : true },
        React.createElement(phone_input_styled_1.StyledPhoneInput, null,
            React.createElement(react_telephone_input_1.ReactTelephoneInput, Object.assign({}, rtiProps)))));
};
exports.PhoneInput = PhoneInput;
//# sourceMappingURL=PhoneInput.js.map